import React, { FC, useEffect, useState } from "react";
import "./OrdersDetail.css";
import CpIcon from "./Icons";
import { useParams, useLocation } from "react-router-dom";
import { State } from "../../store";
import { connect } from "react-redux";
import * as GeneralStore from "../../store/GeneralStore";

import {
  FontSizes,
  FontWeights,
  IconButton,
  IconFontSizes,
  IIconProps,
} from "@fluentui/react";
import { Order, OrderResponse } from "../../models/Order";
import { Get } from "../../api/apiUtils";
import { AiOutlineArrowRight, AiOutlineCheck } from "react-icons/ai";
import OrdersAuxilary from "./OrdersAuxilary";

type Props = GeneralStore.GeneralState & typeof GeneralStore.actionCreators;

const OrdersDetails: FC<Props> = (props: Props) => {
  const { orderNo } = useParams<{ orderNo: string }>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialModality = Number(searchParams.get("modality")) || 0;

  const [activeSection, setActiveSection] = useState("details");
  const [orderData, setOrderData] = useState<Order | null>(null);
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(200);
  const [modality, setModality] = useState<number>(initialModality);

  const getOrderResults = async () => {
    if (!orderNo) return;

    try {
      const response = await Get(
        `/api/Order?salesOrg=ALL&pageNo=${pageNo}&pageSize=${pageSize}&modality=${modality}`,
        false,
        true
      );

      if (!response.ok) {
        console.log("Error fetching data:", response.status);
        return;
      }

      const data: OrderResponse = await response.json();

      if (data.results.length > 0) {
        const selectedOrder = data.results.find(
          (order) => order.orderNo === orderNo
        );

        if (selectedOrder) {
          setOrderData(selectedOrder);
        } else {
          console.log("Order not found");
          setOrderData(null);
        }
      } else {
        console.log("No Data Found");
        setOrderData(null);
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  useEffect(() => {
    getOrderResults();
  }, [orderNo, pageNo, pageSize, modality]);

  const onBack = () => {
    window.history.back(); // Go back to the previous page
  };

  const sectionClick = (section: string) => {
    setActiveSection(section);
  };

  const statusMap: Record<number, string> = {
    0: "Marine",
    1: "Truck",
    2: "Rail",
  };

  const orderMap: Record<number, string> = {
    0: "Pending",
    1: "Processing",
    2: "Completed",
  };

  const backIcon: IIconProps = { iconName: "Back" };
  const settingsIcon: IIconProps = { iconName: "Settings" };
  const upcomingIcon: IIconProps = { iconName: "Forward" };
  const chevronIcon: IIconProps = { iconName: "ChevronRight" };

  const iconHeaderContainerStyle = {
    root: {
      border: "1px solid lightgray ",
      borderRadius: "8px",
      height: "36px",
      width: "36px",
    },
    icon: {
      color: "black",
    },
  };

  const iconChevronHeaderStyle = {
    root: {
      border: "1px solid lightgray ",
      borderRadius: "16px",
      height: "22px",
      width: "22px",
      backgroundColor: "#F5F5F5",
    },
    icon: {
      fontSize: "12px",
      color: "blue",
    },
  };

  const servicesOrderDetailsIcon = {
    root: {
      height: "22px",
      width: "22px",
    },
    icon: {
      fontSize: "12px",
      color: "black",
    },
  };

  return (
    <div className="container-order">
      <div className="header-container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <IconButton
            iconProps={{ iconName: "Back" }}
            title="Go Back"
            ariaLabel="Go Back"
            onClick={onBack}
            styles={iconHeaderContainerStyle}
          />
          <p>Order Details</p>
        </div>
        <IconButton
          iconProps={settingsIcon}
          title="Go Back"
          ariaLabel="Go Back"
          styles={iconHeaderContainerStyle}
          // disabled={disabled}
          // checked={checked}
        />
      </div>

      <div className="header-product-detail">
        <div className="left-header-product-detail">
          <CpIcon iconName="TankIcon" />
          <div>
            <p>{orderData?.nomination.product}</p>
            <p>{orderData?.orderNo}</p>
          </div>
        </div>
        <div className="right-header-product-detail">
          <div className="header-product-box">
            <CpIcon iconName="OpacityIcon" />
            <p>{orderData?.nomination.quantity} </p>
          </div>
          <div className="header-product-box">
            <CpIcon iconName="EventCalendarIcon" />
            <p>{orderData?.createdOn} </p>
          </div>
          <div className="header-product-box">
            <AiOutlineArrowRight
              className="icon"
              style={{
                color: "#0284C7",
                // border: "1px solid lightgray ",
                borderRadius: "16px",
                height: "16px",
                width: "16px",
                backgroundColor: "#F5F5F5",
                fontSize: "12px",
              }}
            />
            <p>Upcoming</p>
          </div>
        </div>
      </div>
      <div className="button-header-container">
        <button
          onClick={() => sectionClick("details")}
          className={
            activeSection === "details" ? "button-active" : "button-inactive"
          }
        >
          <span>Details</span>
        </button>
        <button
          onClick={() => sectionClick("services")}
          className={
            activeSection === "services" ? "button-active" : "button-inactive"
          }
        >
          <span>Services</span>
        </button>
        <button
          onClick={() => sectionClick("auxilary")}
          className={
            activeSection === "auxilary" ? "button-active" : "button-inactive"
          }
        >
          <span>Auxilary Details</span>
        </button>
      </div>

      {activeSection === "details" && (
        <div className="details-container">
          <div className="details-left-container">
            <div className="order-information">
              <p className="order-table-title">Order Information</p>
              <div className="order-table-row">
                <span>Order#:</span>
                <span>{orderData?.orderNo}</span>
              </div>
              <div className="order-table-row">
                <span>Modality:</span>
                <span>
                  {statusMap[Number(orderData?.nomination?.modality)] || "-"}
                </span>
              </div>
              <div className="order-table-row">
                <span>Product:</span>
                <span>{orderData?.nomination.product}</span>
              </div>
              <div className="order-table-row">
                <span>Quantity:</span>
                <span>{orderData?.nomination.quantity}</span>
              </div>
              <div className="order-table-row">
                <span>Nomination:</span>
                <span>{orderData?.nomination.nominationNo}</span>
              </div>
              <div className="order-table-row">
                <span>Status:</span>
                <span>
                  {orderMap[Number(orderData?.nomination?.status)] || "-"}
                </span>
              </div>
            </div>
            <div className="kpi-information">
              <p className="kpi-table-title">Key Performance Indicator</p>
              <div className="kpi-table-row">
                <span>ETA</span>
                <span>
                  {orderData?.nomination.eta ? orderData?.nomination.eta : "-"}
                </span>
              </div>
              <div className="kpi-table-row">
                <span>Arrived Date</span>
                <span>
                  {orderData?.nomination.arrivalDate
                    ? orderData.nomination.arrivalDate
                    : "-"}
                </span>
              </div>
              <div className="kpi-table-row">
                <span>Delivered Date</span>
                <span>-</span>
              </div>
            </div>
          </div>
          <div className="details-right-container">
            <div className="support-information">
              <p className="support-table-title">Key Performance Indicator</p>
              <div className="support-table-row">
                <span>Contact Person:</span>
                <span>John Doe</span>
              </div>
              <div className="support-table-row">
                <span>Email:</span>
                <span>johndoe@gmail.com</span>
              </div>
              <div className="support-table-row">
                <span>Contact Number:</span>
                <span>092929292929</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeSection === "services" && (
        <div className="services-container">
          <div className="services-left-container">
            <table>
              <thead className="table-head">Services added</thead>
              <tbody className="table-body">
                <tr className="table-row">
                  <td>
                    <div className="services-detail-container">
                      <span>{orderData?.orderNo}</span>
                      <div className="services-detail-box">
                        <div className="services-box">
                          <CpIcon iconName="EventCalendarIcon" />
                          <p>{orderData?.createdOn} </p>
                        </div>
                        <div className="services-box">
                          <AiOutlineCheck
                            className="icon"
                            style={{ color: "#65A30D" }}
                          />
                          <p>Completed </p>
                        </div>
                        <div className="services-box">
                          <IconButton
                            iconProps={chevronIcon}
                            title="Go Back"
                            ariaLabel="Go Back"
                            styles={servicesOrderDetailsIcon}
                            // disabled={disabled}
                            // checked={checked}
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* <div className="services-right-container">Right</div> */}
        </div>
      )}

      {activeSection === "auxilary" && (
        <div className="auxilary-container">
          <OrdersAuxilary></OrdersAuxilary>
          {/* <div className="auxilary-left-container">Left</div>
          <div className="auxilary-right-container">Right</div> */}
        </div>
      )}
    </div>
  );
};

export default connect(
  (state: State) => ({
    ...state.general,
  }),
  {
    ...GeneralStore.actionCreators,
  }
)(OrdersDetails);
